import { ReactNode } from "react";
import Tooltip from "antd/lib/tooltip";

export const TooltipElement = ({
  text,
  children,
}: {
  text: string;
  children: ReactNode;
}) => {
  return <Tooltip title={text}>{children}</Tooltip>;
};
